import { FC, memo } from 'react';
import { useRouter } from 'next/router';
import { Button, ButtonProps } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
import { LinksEnum } from '@specs/navigation';
interface Props extends Omit<ButtonProps, 'children' | 'id'> {}
const MemoizedEditButton: FC<Props> = ({
  ...props
}) => {
  const router = useRouter();
  const {
    translate: tr
  } = useTranslation();
  return <Button id='profile_page_edit_button' {...props} onClick={async () => {
    await router.push(LinksEnum.SETTINGS);
  }} data-sentry-element="Button" data-sentry-component="MemoizedEditButton" data-sentry-source-file="EditButton.tsx">
			{tr({
      id: 'btn.edit.profile'
    })}
		</Button>;
};
export const EditButton = memo(MemoizedEditButton);